import type {
	User,
	UserDetails,
	UserFlags,
	UserPasswordUpdate,
	UserPaymentPayload,
	UserPreferences,
	UserProfile,
	UserSignup,
	ApiResponse,
} from "@vita-learning/types";

import { resHttpClient as httpClient } from "../../config";

export const createUser = async (
	userInfo: UserSignup
): Promise<UserDetails> => {
	const resp = await httpClient.post<ApiResponse<UserDetails>>(
		"/users",
		userInfo
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const onboardUser = async (user: User): Promise<UserDetails> => {
	const resp = await httpClient.put<ApiResponse<UserDetails>>("/users", user);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const updateProfile = async (
	profile: UserProfile
): Promise<UserDetails> => {
	const resp = await httpClient.put<ApiResponse<UserDetails>>(
		"/users/profile",
		profile
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const updatePayment = async (
	payload: UserPaymentPayload
): Promise<UserDetails> => {
	const resp = await httpClient.put<ApiResponse<UserDetails>>(
		"/users/payment",
		payload
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const destroyUser = async (): Promise<void> => {
	const resp = await httpClient.delete<ApiResponse<void>>("/users");

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const updatePassword = async (
	password: UserPasswordUpdate
): Promise<void> => {
	const resp = await httpClient.put<ApiResponse<void>>(
		"/users/password",
		password
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const updatePreferences = async (
	preferences: UserPreferences
): Promise<UserDetails> => {
	const resp = await httpClient.put<ApiResponse<UserDetails>>(
		"/users/preferences",
		preferences
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const resendEmailToken = async (userInfo: UserSignup): Promise<void> => {
	const resp = await httpClient.put<ApiResponse<void>>(
		"/users/email/token",
		userInfo
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const setBetaStatus = async (beta: boolean): Promise<void> => {
	const resp = await httpClient.patch<ApiResponse<void>>("/users/beta", {
		beta,
	});

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const updateUserFlags = async (
	flags: Partial<UserFlags>
): Promise<UserDetails> => {
	const resp = await httpClient.patch<ApiResponse<UserDetails>>(
		"/users/flags",
		flags
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};
